var JS_LOADER = function() {

    //external scriptlere erişim olmadığnda(external site down olmuştur veya iatitest network gibi inernet erişim olmayan bir yerde uyg. deploy olmuştur)
    //script tagı ile bu js ler yüklenmeye çalıştığında sayfanın açılmasını bloke edebiliyor. Bunun önüne geçmek için bu şekilde kod ile yükleniyor.
    this.load = function(url, callback){
        var script = document.createElement('script');

        if(callback){
            script.onreadystatechange= function () {
                if (this.readyState == 'complete') callback();
            }
            script.onload= callback;
        }

        script.async = false; //this script should be load before document load.
        script.src = url;
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(script, s);
    }

    this.loadHotelDetailScripts = function(){
        JS_LOADER.load("//maps.google.com/maps/api/js?key="+Globals.Google.mapKey+"&libraries=places&sensor=false", function(){
            JS_LOADER.load("/js/jq/jquery.ui.map.full.min.js", function(){
                JS_LOADER.load("/js/hotel/hotelSearch.js?ver=1.7", function(){
                    JS_LOADER.load("/js/hotel/hotelDetail.js?ver=1.3")
                })
            })
        });
    }

    this.loadHotelScripts = function(){
		if(!HotelResult.isHotelListNotEmpty && !HotelResult.showHotelMap){
	    	JS_LOADER.load("/js/hotel/hotelSearch.js?ver=1.7");
		} else {
	        JS_LOADER.load("//maps.google.com/maps/api/js?key="+Globals.Google.mapKey+"&libraries=places&sensor=false", function(){
	            JS_LOADER.load("/js/gmap/markerclusterer/src/markerclusterer.js",function () {
	                JS_LOADER.load("/js/gmap/markerwithlabel.js",function () {
	                    JS_LOADER.load("/js/jq/jquery.ui.map.full.min.js", function(){
	                        JS_LOADER.load("/js/hotel/hotelSearch.js?ver=1.7", function(){
	                            JS_LOADER.load("/js/hotel/countryHotelMap.js?ver=1.2", function(){
	                                if(HotelResult.isHotelListNotEmpty){
	                                    JS_LOADER.load("/js/hotel/hotelResult.js?ver=1.1")
	                                }
	                            })
	                        })
	                    })
	                })
	            })
	        });
		}
    }

    this.loadTransferScripts = function(){
        JS_LOADER.load("//maps.google.com/maps/api/js?key="+Globals.Google.mapKey, function(){
            JS_LOADER.load("/js/jq/jquery.ui.map.full.min.js", function(){
                JS_LOADER.load("/js/transfer/transferMap.js");
            })
        });
    }

    this.loadHouseScripts = function(){
        JS_LOADER.load("//maps.google.com/maps/api/js?key="+Globals.Google.mapKey, function(){
            JS_LOADER.load("/js/gmap/markerclusterer/src/markerclusterer.js",function () {
                JS_LOADER.load("/js/gmap/markerwithlabel.js",function () {
                    JS_LOADER.load("/js/jq/jquery.ui.map.full.min.js", function(){
                        JS_LOADER.load("/js/house/houseSearch.js?ver=1.5", function(){
                            JS_LOADER.load("/js/house/countryHouseMap.js", function(){
                                if(HouseResult.isHouseListNotEmpty){
                                    JS_LOADER.load("/js/house/houseResult.js?ver=1.1")
                                }
                            });
                        })
                    })
                })
            })
        });

    }

    this.loadHouseDetailScripts = function(){
        JS_LOADER.load("//maps.google.com/maps/api/js?key="+Globals.Google.mapKey, function(){
            JS_LOADER.load("/js/jq/jquery.ui.map.full.min.js", function(){
                JS_LOADER.load("/js/house/houseSearch.js?ver=1.5", function(){
                    JS_LOADER.load("/js/house/houseDetail.js?ver=1.0")
                })
            })
        });
    }

    this.loadYachtScripts = function(){
        JS_LOADER.load("//maps.google.com/maps/api/js?key="+Globals.Google.mapKey, function(){
            JS_LOADER.load("/js/gmap/markerclusterer/src/markerclusterer.js",function () {
                JS_LOADER.load("/js/jq/jquery.ui.map.full.min.js", function(){
                    JS_LOADER.load("/js/yacht/yachtSearch.js?ver=1.4", function(){
                        if(YachtResult.isYachtListNotEmpty){
                            JS_LOADER.load("/js/yacht/yachtResult.js")
                        }
                    })
                })
            })
        });
    }

    this.loadYachtDetailScripts = function(){
        JS_LOADER.load("//maps.google.com/maps/api/js?key="+Globals.Google.mapKey, function(){
            JS_LOADER.load("/js/jq/jquery.ui.map.full.min.js", function(){
                JS_LOADER.load("/js/yacht/yachtSearch.js?ver=1.4", function(){
                    JS_LOADER.load("/js/yacht/yachtDetail.js?ver=1.0")
                })
            })
        });
    }


    return {
        load : load,
        loadHotelDetail:loadHotelDetailScripts,
        loadHotel:loadHotelScripts,
        loadTransfer:loadTransferScripts,
        loadHouse:loadHouseScripts,
        loadHouseDetail:loadHouseDetailScripts,
        loadYacht:loadYachtScripts,
        loadYachtDetail:loadYachtDetailScripts
    }
}();
